import { Component, OnInit, ViewChild } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { clientMaster } from 'src/app/Models/BasicForms/clientMaster';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-client-master',
  templateUrl: './client-master.component.html',
  styleUrls: ['./client-master.component.css']
})

export class ClientMasterComponent implements OnInit {
  constructor(public _apiService: ApiService, private notificationService: NzNotificationService) { }

  formTitle = "Client";

  ngOnInit(): void {
    this.getAllClients();

    this.logtext = 'OPENED - Client Master form KEYWORD[O - Client Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = "desc";
  logtext: string = "";
  searchText: string = "";
  columns: string[][] = [["INDUSTRY_NAME", "Industry"], ["NAME", "Client Name"], ["INDUSTRY_ADDRESS", "Address"], ["INDUSTRY_CITY", "City"], ["INDUSTRY_PINCODE", "Pincode"], ["EMAIL_ID", "Email"], ["MOBILE_NO", "Mobile No."]];
  filterQuery: string = "";
  isloadSpinning = false;
  loadingRecords = false;
  clientData: [];

  getAllClients(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }

    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";
      this.logtext = 'Filter Applied - Client Master form"+ sort +" "+this.sortKey +" KEYWORD [F - Client Master] ';
      this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
        if (successCode['code'] == "200") {

        }
        else {

        }
      });
    } catch (error) {
      sort = "";
    }


    if (this.searchText != "") {
      var likeQuery = " AND";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2)

    }

    this.logtext = 'Filter Applied - Client Master form "+ likeQuery +" KEYWORD [F - Client Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });

    this._apiService.getAllClients(this.pageIndex, this.pageSize, this.sortKey, sort, likeQuery).subscribe(data => {

      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.clientData = data['data'];

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }

  drawerVisible = false;
  drawerTitle = "";
  clientDrawerData: clientMaster = new clientMaster();

  add() {
    this.drawerTitle = "Create Client";
    this.clientDrawerData = new clientMaster();
    this.drawerVisible = true;
    this.clientDrawerData.IS_ACTIVE = true;

    this.logtext = 'ADD - Client Master form KEYWORD [A - Client Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  edit(data: clientMaster) {
    this.drawerTitle = "Update Client Details";
    this.clientDrawerData = Object.assign({}, data);
    this.drawerVisible = true;



    this.logtext = 'EDIT - Client Master form KEYWORD [E - Client Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  drawerClose() {
    this.getAllClients();
    this.drawerVisible = false;
  }

  get callBackDrawerClose() {
    return this.drawerClose.bind(this);
  }

  sortKey: string = "id";

  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find(item => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'id';
    const sortOrder = (currentSort && currentSort.value) || 'desc';



    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;
    this.getAllClients();
  }
}
